import { useApiClientStore } from '../stores/useApiClientStore';
import { InvoicePayment, InvoicePaymentConfirmation } from '../types/payment';

export async function fetchInvoicePaymentApi(invoiceId: string): Promise<InvoicePayment> {
  const api = useApiClientStore().getClient();
  return api.get<InvoicePayment>(`/patient-portal/invoice-payment/${invoiceId}`);
}

export async function fetchInvoicePaymentConfirmationApi(
  invoiceId: string,
): Promise<InvoicePaymentConfirmation> {
  const api = useApiClientStore().getClient();
  return api.get<InvoicePaymentConfirmation>(
    `/patient-portal/invoice-payment/${invoiceId}/confirmation`,
  );
}
